/* eslint-disable */
import React, { useMemo,useState,useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import { CTitle, STitle } from '../../components/Widget';
import QRightBg from './../../../../../../assets/education/ptm/q_right_bg.png';
import AiLeftBg from './../../../../../../assets/education/ptm/ai_left_bg.png';
import AiRightBg from './../../../../../../assets/education/ptm/ai_right_bg.png';
import FactorRightBg from './../../../../../../assets/education/ptm/factor_right_bg.png';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import { useUpdateComponentState } from '../../../hooks';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const [state, setState] = useState({
    useChecked: [] as any,
    useActive: 0  as any,
    play: 1,
    isPlayed: false,
    factorPlay: 1,
    isFactorPlayed: false,
  });
  const [activeArr, setActiveArr] = useState([0,1,2,3]);
  const updateComponentState = useUpdateComponentState()
  const getArrayMin = (arr: any,value:any) => {
    const newArr = arr.filter((item:any) => item !== value)
    setActiveArr([...newArr])
    if (!Array.isArray(newArr) || newArr.length === 0) return null;
    return Math.min(...newArr);
  };
  const tapUse = (i:any) =>{
    if(!state.useChecked.includes(i)){
      const min = getArrayMin(activeArr,i)
      setState({...state,useChecked:[...state.useChecked,i],useActive:min})
    }
  }
  useEffect(() => {
    if(state.useChecked.length>=4){
      updateComponentState(p_course, p_topic, ID,'education-ptm-section1-1')
    }
    if (state.play >= 6) {
      updateComponentState(p_course, p_topic, ID, 'education-ptm-section1-2');
      // updateParagraphState(p_course, p_topic, ID, 'completed', []);
    }
    if(state.factorPlay>=4){
      updateComponentState(p_course, p_topic, ID, 'education-ptm-section1-3');
    }
  }, [state.play,state.factorPlay,state.useChecked]);
  const startPlay = (next = 1) => {
    if (state.isPlayed) {
      return;
    }
    next += 1;
    setState({...state, play: next, isPlayed: true });
    if (next <= 6) {
      setTimeout(() => startPlay(next), 1000);
    }
  };
  const startFactorPlay = (next = 1) => {
    if (state.isFactorPlayed) {
      return;
    }
    next += 1;
    setState({...state, factorPlay: next, isFactorPlayed: true });
    if (next <= 4) {
      setTimeout(() => startFactorPlay(next), 1000);
    }
  };
  return (
    <div className="topic-section-2">
      <CTitle title={paragraphsSettings?.title} />
      <div className="use" id="education-ptm-section1-1">
        <div className="use-tip">{paragraphsSettings?.tips1}</div>
        <div className="use-action">
          {paragraphsSettings?.l1.map((item: any, i: number) => (
            <div
              className={`use-box ${
                state.useChecked.includes(i) ? 'clicked' : ''
              }`}
              key={i}
            >
              <div className="use-item" onClick={() => tapUse(i)}>
                <div className={`use-item-front front-${i + 1}`}>
                  <div
                    className="use-item-title"
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                  <div className="use-item-content">{item.content}</div>
                </div>
                <div className={`use-item-back back-${i + 1}`}>
                  <div
                    className="use-item-title"
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                </div>
                {state.useActive === i && (
                  <img src={ImgPoint} alt="" className="img-point" />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="issue-title">
        <STitle title={paragraphsSettings?.l2Title} />
      </div>
      <div className="issue-content">
        <div className="silder-list">
          {paragraphsSettings?.l2?.map((item: any, i: number) => (
            <div className="silder-list-item" key={i}>
              <div className="hexagon">{i + 1}</div>
              <div className="item-left">
                <h3>{item?.title}</h3>
                <p>{item?.content}</p>
              </div>
            </div>
          ))}
        </div>
        <img className="issue-content-bg" src={QRightBg} alt="" />
      </div>
      <div className="ai-title" id="education-ptm-section1-2">
        <STitle title={paragraphsSettings?.l3Title} />
      </div>
      <div className="ai-content" onClick={() => startPlay()}>
        {state.play <= 1 && <img src={ImgPoint} alt="" className="img-point" />}
        <img src={AiRightBg} alt="" className="img-right" />
        <img src={AiLeftBg} alt="" className="img-left" />
        {paragraphsSettings?.l3?.map((item: string, i: number) => (
          <div
            className={`content-item content-item-${i + 1} ${
              state.play > i ? 'box-fade-in' : ''
            }`}
            key={i}
          >
            <span>{item}</span>
          </div>
        ))}
      </div>
      <div className="factor-title">
        <STitle title={paragraphsSettings?.l4Title} />
      </div>
      <div
        className="factor-content"
        id="education-ptm-section1-3"
        onClick={() => startFactorPlay()}
      >
        { state.factorPlay <=1&&<img src={ImgPoint} alt="" className="img-point" />}
        <img className="img-right" src={FactorRightBg} alt="" />
        <div className="factor-tips">{paragraphsSettings?.l4Tip}</div>
        {paragraphsSettings?.l4?.map((item: string, i: number) => (
          <div
            className={`factor-item factor-item-${i + 1} ${
              state.factorPlay > i ? 'box-fade-right-in' : ''
            }`}
            key={i}
          >
            <span>{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Section1;
